import toast from "react-hot-toast"
import { postAPICall } from "./config"
import { accessToken, rootUrl } from "./constant"

export const subscribeBlogAPI = (data, setLoader, handleSuccess) => {

    const options = {
        headers: {
            Token: accessToken
        }
    }

    return (dispatch) => {
        postAPICall(`${rootUrl}/newsletter/subscribe`, data, options)
            .then(res => {
                handleSuccess()
                toast.success('Subscribed Successfully')
            })
            .catch(err => {
                setLoader(false)
                console.log({ err })
            })
    }
}

export const contactUsAPI = (data, setLoader, handleSuccess) => {

    const options = {
        headers: {
            Token: accessToken
        }
    }

    return (dispatch) => {
        postAPICall(`${rootUrl}/inquiry/contactUs/submit`, data, options)
            .then(res => {
                handleSuccess()
            })
            .catch(err => {
                setLoader(false)
                console.log({ err })
            })
    }
}

export const hireTalentAPI = (data, setLoader, handleSuccess) => {

    const options = {
        headers: {
            Token: accessToken
        }
    }

    return (dispatch) => {
        postAPICall(`${rootUrl}/inquiry/careers/submit`, data, options)
            .then(res => {
                handleSuccess()
            })
            .catch(err => {
                setLoader(false)
                console.log({ err })
            })
    }
}

export const downloadEBookAPI = (data, setLoader, handleCallback) => {

    const options = {
        headers: {
            Token: accessToken
        }
    }

    return (dispatch) => {
        postAPICall(`${rootUrl}/eBook/download`, data, options)
            .then(res => {
                handleCallback(setLoader);
            })
            .catch(err => {
                setLoader(false)
                console.log({ err })
            })
    }
}